import React, { useEffect, useState } from "react";
import CustomModal from "../../../components/custom-modal/CustomModal";
import { Box, TextField, Button } from "@mui/material";
import i18n from "../../../i18n/i18n";
import { v4 as uuidv4 } from 'uuid';

import { useAppDispatch, useAppSelector } from "../../../hooks";
import { setOpenModalAddStandard } from "../slices/modalAddStandardSlice";
import { DataGrid, GridColDef, GridPaginationModel } from "@mui/x-data-grid";
import {
  Article,
  fetchArticles,
  addSelectedArticle,
  removeSelectedArticle,
} from "../slices/articleStandardSlice";
import { fetchArticleTarif } from "../slices/articleTarifSlice";

interface ArticleWithQuantity extends Article {
  quantity?: number;
  isAdded?: boolean;
  typeArticle?: string;
}

const ModalAddStandard = () => {
  const dispatch = useAppDispatch();
  const { isOpenModalAddStandard } = useAppSelector(
    (state) => state.modalAddStandardSlice
  );
  const { client, siteExpedition, siteVente } = useAppSelector((state) => state.preOrderFilterSlice);

  const { articles, status, error, selectedArticles } = useAppSelector(
    (state) => state.articleStandardSlice
  );

  const [searchPattern, setSearchPattern] = useState<string>("");
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    pageSize: 5,
    page: 0,
  });
  const [articleData, setArticleData] = useState<ArticleWithQuantity[]>([]);
  const [gridKey, setGridKey] = useState<number>(0);

  useEffect(() => {
    if (isOpenModalAddStandard) {
      dispatch(
        fetchArticles({ searchPattern, pageNumber: paginationModel.page + 1 })
      );
    }
  }, [isOpenModalAddStandard, paginationModel, searchPattern, dispatch]);

  useEffect(() => {
    const updatedArticles = articles.map((article) => ({
      ...article,
      quantity: 0,
      // isAdded: selectedArticles.some(
      //   (selected) => selected.Reference === article.Reference
      // ),
      typeArticle: "standard",
    }));
    setArticleData(updatedArticles);

  }, [articles, selectedArticles]);

  useEffect(() => {

    setGridKey((prevKey) => prevKey + 1);
  }, [articleData]);

  const handleCloseModal = () => {
    dispatch(setOpenModalAddStandard(false));
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchPattern(event.target.value);
    setPaginationModel({ ...paginationModel, page: 0 });
  };

  const handleQuantityChange = (reference: string, value: number) => {
    if (value >= 0) {
      const updatedArticles = articleData.map((article) =>
        article.Reference === reference
          ? { ...article, quantity: value }
          : article
      );
      setArticleData(updatedArticles);
    }
  };

  // const handleAddRemoveClick = async (index: number) => {
  //   const article = articleData[index];
  //   if (article) {
  //     if (article.isAdded) {
  //       dispatch(removeSelectedArticle(index));
  //       const updatedArticles = [...articleData];
  //       // updatedArticles[index].isAdded = false;
  //       setArticleData(updatedArticles);
  //     } else {
  //       const response = await dispatch(
  //         fetchArticleTarif({
  //           codeClient: client?.NumeroClient,
  //           codeArticle: article.Reference,
  //           siteVente: siteVente?.Code,
  //           siteExpedition: siteExpedition?.Code,
  //           quantite: article.quantity ?? 1,
  //           unite: article.Unite,
  //           devise: "MAD",
  //           dateCommande: "",
  //         })
  //       );

  //       if (fetchArticleTarif.fulfilled.match(response)) {
  //         const { netpri } = response.payload as { netpri: number };
  //         const updatedArticles = [...articleData];
  //         updatedArticles[index] = {
  //           ...article,
  //           // isAdded: true,
  //           price: netpri,
  //         };
  //         setArticleData(updatedArticles);
  //         dispatch(addSelectedArticle({ ...article, price: netpri }));
  //       } else {
  //         console.error("Failed to fetch article tariff:", response.error);
  //       }
  //     }
  //   }
  // };

  const handleAddClick = async (index: number) => {
    const article = articleData[index];
    if (!article || (article.quantity ?? 0) <= 0) return;

    const response = await dispatch(
      fetchArticleTarif({
        codeClient: client?.NumeroClient,
        codeArticle: article.Reference,
        siteVente: siteVente?.Code,
        siteExpedition: siteExpedition?.Code,
        quantite: article.quantity ?? 1,
        unite: article.Unite,
        devise: "MAD",
        dateCommande: "",
      })
    );

    if (fetchArticleTarif.fulfilled.match(response)) {
      const { netpri } = response.payload as { netpri: number };
      dispatch(addSelectedArticle({ ...article, price: netpri, id: uuidv4() }));
    } else {
      console.error("Erreur tarif:", response.error);
    }
  };

  const columns: GridColDef[] = [
    {
      field: "Reference",
      headerName: "Référence",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Description",
      headerName: "Description",
      flex: 2,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Unite",
      headerName: "Unité",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "quantity",
      headerName: "Quantité",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box pt={1.5}>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              value={params.row.quantity}
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                handleQuantityChange(
                  params.row.Reference,
                  isNaN(value) ? 0 : value
                );
              }}
              disabled={params.row.isAdded}
              inputProps={{ min: 0 }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  backgroundColor: "#f0f0f0",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  transition: "box-shadow 0.3s, border-color 0.3s",
                  "&:hover": {
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  },
                  "&.Mui-focused": {
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                    borderColor: "#1976d2",
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ccc",
                },
                "& .MuiInputBase-input": {
                  padding: "8px 12px",
                  textAlign: "center",
                },
                width: "60%",
                height: "15px",
              }}
            />
          </Box>
        </Box>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Button
          variant="contained"
          // color={params.row.isAdded ? "error" : "primary"}
          color="primary"
          onClick={() => handleAddClick(articleData.indexOf(params.row))}
          // disabled={params.row.quantity <= 0 && !params.row.isAdded}
          disabled={params.row.quantity <= 0}
          sx={{
            textTransform: "none",
            borderRadius: "25px",
            width: "80%",
          }}
        >
          {/* {params.row.isAdded ? "Retirer" : "Ajouter"} */}
          {"Ajouter"}

        </Button>
      ),
    },
  ];

  return (
    <CustomModal
      sx={{
        width: "70%",
        position: "absolute",
        top: "30%",
        left: "50%",
        transform: "translate(-50%, -30%)",
      }}
      handleClose={handleCloseModal}
      isOpen={isOpenModalAddStandard}
      title={i18n.t("newPreOrder.buttons.standardAdd")}
    >
      <Box
        sx={{
          maxHeight: 400,
          width: "100%",
          overflowY: "auto",
          padding: "2% 0%",
        }}
      >
        <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchPattern}
          onChange={handleSearchChange}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              backgroundColor: "#f0f0f0",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              transition: "box-shadow 0.3s, border-color 0.3s",
              "&:hover": {
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              },
              "&.Mui-focused": {
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                borderColor: "#1976d2",
              },
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            },
            "& .MuiInputBase-input": {
              padding: "8px 12px",
            },
          }}
        />
        {status === "loading" && <div>Loading...</div>}
        {status === "failed" && (
          <div style={{ color: "red" }}>
            Error de chargement des articles
          </div>
        )}
        {status === "succeeded" && (
          <DataGrid
            key={gridKey} // Utilisez la clé ici
            rows={articleData}
            columns={columns}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[5, 10, 20]}
            pagination
            autoHeight
            disableRowSelectionOnClick
            getRowId={(row) => row.Reference}
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
                color: "none",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#fafafa",
                borderBottom: "1px solid #f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
            }}
          />
        )}
      </Box>
    </CustomModal>
  );
};

export default ModalAddStandard;
